import InternshipModal from "./InternshipModal";
import type { InternshipFormData } from "./InternshipModal";

export type { InternshipFormData };
export default InternshipModal;
